<div class="deviceInfo" *ngIf="!isMobile" (click)="isShowInfo = !isShowInfo">
    <div class="deviceText">{{'deviceInfo.title' | translate}}</div>
    <div class="info" *ngIf="isShowInfo">
        <p *ngIf="deviceInfo.Platform">Platform = {{deviceInfo.Platform}}</p>
        <p *ngIf="deviceInfo.Browser">Browser = {{deviceInfo.Browser}}</p>
        <!-- <p *ngIf="deviceInfo.FlashPlugIn">Flash plug-in = {{deviceInfo.FlashPlugIn}}</p>
            <p *ngIf="deviceInfo.AdobeReader">Adobe Reader = {{deviceInfo.AdobeReader}}</p>
            <p *ngIf="deviceInfo.Javaversion">Java version = {{deviceInfo.Javaversion}}</p>
            <p *ngIf="deviceInfo.CookiesEnabled">Cookies enabled = {{deviceInfo.CookiesEnabled}}</p>
            <p *ngIf="deviceInfo.ConnectionType">Connection type = {{deviceInfo.ConnectionType}}</p>
            <p *ngIf="deviceInfo.PopupsEnabled">Popups enabled = {{deviceInfo.PopupsEnabled}}</p> -->
        <p *ngIf="deviceInfo.IP">IP = {{deviceInfo.IP}}</p>
        <p *ngIf="deviceInfo.Proxy">Proxy = {{deviceInfo.Proxy}}</p>
        <p *ngIf="deviceInfo.Login">Login = {{deviceInfo.Login}}</p>
    </div>
</div>
<div class="deviceInfo-mobile" *ngIf="isMobile">
    <div class="deviceText">{{'deviceInfo.title' | translate}}</div>
    <div class="info-mobile">
        <p>Platform = {{deviceInfo.Platform}}</p>
        <p>Browser = {{deviceInfo.Browser}}</p>
        <p>IP = {{deviceInfo.IP}}</p>
        <p>Proxy = {{deviceInfo.Proxy}}</p>
        <p>Login = {{deviceInfo.Login}}</p>
    </div>
</div>